export const renderCurrencyCell = ({ value }) =>
	isNaN(Number(value))
		? "$0.00"
		: `$${Number(value).toLocaleString(undefined, {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			})}`;

export const renderPercentageCell = ({ value }) => (isNaN(Number(value)) ? "0%" : `${(Number(value) * 100).toFixed(2)}%`);

const defaultHeaderProps = {
	headerAlign: "left",
	align: "left",
};

export const createCol = (field, headerName, type = null, isCurrency = false, isPercentage = false, flex = 1, minWidth = 150) => ({
	field,
	headerName,

	flex,
	minWidth,

	...(type && { type }),
	...defaultHeaderProps,
	...(isCurrency && { renderCell: renderCurrencyCell }),
	...(isPercentage && { renderCell: renderPercentageCell }),
});

const renderFullNameColumn = ({ row }) => `${row.first_name ?? ""} ${row.last_name ?? ""}`.trim();

export const columns = [
	{
		field: "full_name",
		headerName: "Name",
		flex: 1.5,
		minWidth: 170,
		...defaultHeaderProps,
		renderCell: renderFullNameColumn,
	},
	createCol("email", "Email", null, false, false, 1.5, 250),
	createCol("phone", "Phone", null, false, false, 0.7, 120),

	createCol("applicant_count", "Applicants", null, false, false, 0.5, 100),
	createCol("carrier_provided_identifier", "Policy ID / CPI", null, false, false, 0.8, 120),
	createCol("policy_status", "Policy Status", null, false, false, 1, 180),

	createCol("issuer", "Carrier", null, false, false, 1.5, 120),
];
